import { createReducer } from '@reduxjs/toolkit';

import getBrandList from '../../thunks/general/getBrandList';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const getBrandListReducer = createReducer(initialState, {
  [getBrandList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getBrandList.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    data: data.map(({ name }) => ({ label: name, value: name })),
    loading: false,
  }),
  [getBrandList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getBrandListReducer;
